// extracted by mini-css-extract-plugin
export var form = "index-module--form--+FO5T";
export var title = "index-module--title--KHysP";